import InvestmentsLogoImg from "@/assets/investmentslogo.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const InvestmentsLogo = (props: Props) => (
  <LogoImage imgSrc={InvestmentsLogoImg} alt="Investments Logo" size="navbar" {...props} />
);
